import { Platform, type ViewProps } from 'react-native';

/**
 * DOM props forwarded by react-native-web for SR-friendly eyebrow regions.
 * Intersected with ViewProps so spreads onto `<View>` type-check without assertions.
 */
type WebEyebrowTextRegionWebProps = Partial<ViewProps> & {
  role: 'text';
  'aria-label': string;
  tabIndex: 0;
};

/**
 * Small uppercase “eyebrow” lines (e.g. FIREHOUSE REWARDS) are plain Text and are often
 * skipped on RN Web; expose them like other page-builder copy via a focusable region + label.
 *
 * RN Web forwards `role` / `aria-*` / `tabIndex` to the DOM; core `ViewProps.role` uses a
 * narrower `Role` union that does not list `"text"`, so the web branch is typed as
 * `WebEyebrowTextRegionWebProps` instead of forcing `Partial<ViewProps>` alone.
 */
export function webEyebrowTextRegionProps(label: string): Partial<ViewProps> | WebEyebrowTextRegionWebProps {
  if (Platform.OS !== 'web' || !label.trim()) {
    return {};
  }
  const trimmed = label.trim();
  return {
    role: 'text',
    'aria-label': trimmed,
    tabIndex: 0,
  } as unknown as Partial<ViewProps>;
}
